// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y62T","content":"styles_content__2Naz4","list":"styles_list__QhfMt","item":"styles_item__3l6Tl","button":"styles_button__1DgGS"};